import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchRecordsFromDatabase,handleSearchById, handleSearchByOwner } from './api';
import { Button, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogContent, Box } from '@mui/material';
import RecordForm from './RecordForm';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import MoveJobPage from './MoveJobPage';
import LanguageIcon from '@mui/icons-material/Language';

import SearchIcon from '@mui/icons-material/Search';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';

const App = () => {
  const { t, i18n } = useTranslation();
  const [openMoveDialog, setOpenMoveDialog] = useState(false);
  const [records, setRecords] = useState([]);
  const [searchLot, setSearchLot] = useState('');
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [revKey, setRevKey] = useState(0);
  const [searchResult, setSearchResult] = useState(null); 

  const toggleLanguage = () => {
    const nextLanguage = i18n.language === 'en' ? 'cs' : 'en';
    i18n.changeLanguage(nextLanguage);
  };

const handleMoveJobClick = () => {
  setOpenMoveDialog(true);
};

  const handleOpenModal = (record = null) => {
    setSelectedRecord(record);
    setIsEditMode(!!record);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRecord(null);
    setIsEditMode(false);
  };


  const fetchData = async () => {
    const data = await fetchRecordsFromDatabase(); 
    setRecords(data);
  };

  useEffect(() => {
    fetchData();
    console.log(revKey);
  }, [revKey]);


  const getAmmountText = (count, unitId) => {
    const unitKeys = {
      1: 'pallet',
      2: 'box',
      3: 'piece',
      4: 'case',
      5: 'vial'
    };
    const key = unitKeys[unitId] || 'pallet';
    return t(`units.${key}`, { count });
  };

const handleSearch = async () => {
  const result =   await handleSearchById(searchLot);
  console.log(result);
  setRecords(result);
};

const handleSearchOwner = async () => {
  const result =   await handleSearchByOwner();
  console.log(result);
  setRecords(result);
};

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
        <h1>{t('app.title')}</h1>
        <Box>
          <Button 
            variant="outlined" 
            startIcon={<HomeIcon />} 
            onClick={fetchData}
            style={{ marginRight: '10px' }}
          >
            {t('common.home')}
          </Button>
          <Button 
            variant="outlined" 
            startIcon={<LanguageIcon />} 
            onClick={toggleLanguage}
          >
            {i18n.language === 'en' ? t('common.switch_to_cs') : t('common.switch_to_en')}
          </Button>
        </Box>
      </Box>

      <div style={{justifyContent:'left', display:'flex', marginTop: '10px'}}>
      <input
        type="text"
        value={searchLot}
        onChange={(e) => setSearchLot(e.target.value)}
        placeholder={t('app.search_placeholder')}
        style={{margin: '5px'}}
      /> 
      <Button variant="contained" style={{margin: '5px'}} onClick={handleSearch} endIcon={<SearchIcon/>} color="primary">{t('common.search')}</Button>
  
         <Button  variant="contained" color="primary" style={{margin: '5px'}} onClick={handleSearchOwner} endIcon={<PersonSearchIcon/>}>{t('common.my_shipments')}</Button>
         <Button  variant="contained" color="primary" style={{margin: '5px'}} onClick={() => handleOpenModal()} endIcon={<AddIcon/>}>{t('common.create_new')}</Button>
       {/*  <Button  variant="contained" color="primary" style={{ margin: '5px' }} onClick={handleMoveJobClick} endIcon={<SwapHorizIcon />}>{t('common.date_tool')}</Button> */}
      </div>

      <TableContainer component={Paper} style={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('table.lot_id')}</TableCell>
              <TableCell>{t('table.fms_id')}</TableCell>
              <TableCell>{t('table.date')}</TableCell>
              <TableCell>{t('table.alias')}</TableCell>
              <TableCell>{t('table.name')}</TableCell>
              <TableCell>{t('table.amount')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {Array.isArray(searchResult) ? (
          searchResult.map((res) => (
    <TableRow key={res.lot} onClick={() => handleOpenModal(res)}  sx={{ cursor: 'pointer', bgcolor : res.active === false ? "error.main":"" }}>
      <TableCell>{res.lot}</TableCell>
      <TableCell>{res.fmsid}</TableCell>
      <TableCell>{new Date(res.date).toLocaleDateString('en-GB')}</TableCell>
      <TableCell>{res.alias}</TableCell>
      <TableCell>{res.name}</TableCell>
      <TableCell>{res.ammount} {getAmmountText(res.ammount, res.unit)}</TableCell>
    </TableRow>))
  ) : (
    Array.isArray(records) && records.length > 0 ? (
      records.map((record) => (
        <TableRow key={record.lot} onClick={() => handleOpenModal(record)} sx={{ cursor: 'pointer', bgcolor : record.active === false ? "error.main":"" }}>
          <TableCell>{record.lot}</TableCell>
          <TableCell>{record.fmsid}</TableCell>
          <TableCell>{new Date(record.date).toLocaleDateString('en-GB')}</TableCell>
          <TableCell>{record.alias}</TableCell>
          <TableCell>{record.name}</TableCell>
          <TableCell>{record.ammount} {getAmmountText(record.ammount, record.unit)}</TableCell>
        </TableRow>
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={6} style={{ textAlign: 'center' }}>
          {t('common.no_records')}
        </TableCell>
      </TableRow>
    )
  )}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogContent >
          <RecordForm 
            selectedRecord={selectedRecord}
            setIsEditMode={setIsEditMode}
            setSelectedRecord={setSelectedRecord}
            handleClose={handleCloseModal}
            setRevKey={setRevKey}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openMoveDialog} onClose={() => setOpenMoveDialog(false)} maxWidth="md" fullWidth>
  <DialogContent>
    <MoveJobPage />
    <div style={{ textAlign: 'right', marginTop: '10px' }}>
      <Button onClick={() => setOpenMoveDialog(false)}>{t('common.close')}</Button>
    </div>
  </DialogContent>
</Dialog>
    </Container>
  );
};

export default App;
